/* eslint-disable prettier/prettier */
import React, { useState } from 'react'
import { IconButton, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core'
import { ThumbUpAlt, ThumbDownAlt, Favorite, EmojiEmotions } from '@material-ui/icons'
import useSignal from '../../hooks/useSignal'
import { EMOJIS } from '../../hooks/utils'

export default function ReactionsButton({ classes, room, roomId }) {
  const ITEM_HEIGHT = 48
  const [anchorEl, setAnchorEl] = useState(null)
  const [reaction, setReaction] = useState(null) // Para mostrar o emoji temporariamente
  const open = Boolean(anchorEl)
  const { sendSignal } = useSignal({ room, roomId })


  // Abrir e fechar o menu
  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  // Enviar reação
  const triggerReaction = type => {
    // Exibe o emoji localmente
    const elementToInsertEmoji = 'MP_camera_publisher_default_controls'
    const node = document.createElement('div')
    node.appendChild(document.createTextNode(EMOJIS[type]))
    node.classList.add(classes.reactionContainer)
    
    const parentElement = document.getElementById(elementToInsertEmoji)
    parentElement?.appendChild(node)
  
    // Remove o emoji ao final da animação
    node.addEventListener('animationend', () => {
      parentElement?.removeChild(node)
    })
  
    // Envia o sinal para os outros participantes
    sendSignal(type, 'emoji')
  }

  // Renderizar o emoji baseado no tipo
  const renderEmoji = type => {
    switch (type) {
      case 'thumbsup':
        return <ThumbUpAlt className={classes.reactionEmoji} />
      case 'thumbsdown':
        return <ThumbDownAlt className={classes.reactionEmoji} />
      case 'love':
        return <Favorite className={classes.reactionEmoji} />
      default:
        return null
    }
  }

  return (
    <div>
      {/* Botão para abrir o menu */}
      <Tooltip title="Reações">
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          className={classes.toolbarButtons}
          onClick={handleClick}
        >
          <EmojiEmotions />
        </IconButton>
      </Tooltip>

      {/* Menu de opções */}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '10ch'
          }
        }}
      >
        <MenuItem onClick={() => triggerReaction('thumbsup')}>
          <Typography variant="inherit">
            <ThumbUpAlt />
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => triggerReaction('thumbsdown')}>
          <Typography variant="inherit">
            <ThumbDownAlt />
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => triggerReaction('love')}>
          <Typography variant="inherit">
            <Favorite />
          </Typography>
        </MenuItem>
      </Menu>

      {/* Emoji temporário */}
      {reaction && <div className={classes.reactionContainer}>{renderEmoji(reaction)}</div>}
    </div>
  )
}
